import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { ContainerComponent } from './components/container/container.component';
import { InfoCardComponent } from './pages/info-card/info-card.component';
import { InfoFiltroComponent } from './pages/info-filtro/info-filtro.component';
import { exclusivoMoradoresComponent } from './pages/exclusivo-moradores/exclusivo-moradores.component';
import { CalendarComponent } from './pages/calendario/calendar.component';

import { AuthGuard } from '../../auth.guard';
import { TipoPortal } from './services/authService/auth.service';

import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { EspacoDoAlunoComponent } from './pages/espaco-do-aluno/espaco-do-aluno.component';
import { EspacoAlunoLayoutComponent } from './layouts/espaco-aluno-layout/espaco-aluno-layout.component';
import { EspacoDoProfessorComponent } from './pages/espaco-do-professor/espaco-do-professor.component';
import { EspacoProfessorLayoutComponent } from './layouts/espaco-professor-layout/espaco-professor-layout.component';
import { EspacoDaFamiliaComponent } from './pages/espaco-da-familia/espaco-da-familia.component';
import { EspacoFamiliaLayoutComponent } from './layouts/espaco-familia-layout/espaco-familia-layout.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: '', component: ContainerComponent },
      { path: 'info/:name', component: InfoCardComponent },
      { path: 'info/filtro/:name', component: InfoFiltroComponent },
      {
        path: 'exclusivo-moradores/:name',
        component: exclusivoMoradoresComponent,
      },
      { path: 'calendario', component: CalendarComponent },

      {
        path: 'espaco-aluno/dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: { portal: 'aluno' as TipoPortal },
      },
      {
        path: 'espaco-professor/dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: { portal: 'professor' as TipoPortal },
      },
      {
        path: 'espaco-familia/dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: { portal: 'familia' as TipoPortal },
      },
    ],
  },

  {
    path: 'espaco-aluno',
    component: EspacoAlunoLayoutComponent,
    children: [{ path: '', component: EspacoDoAlunoComponent }],
  },
  {
    path: 'espaco-professor',
    component: EspacoProfessorLayoutComponent,
    children: [{ path: '', component: EspacoDoProfessorComponent }],
  },
  {
    path: 'espaco-familia',
    component: EspacoFamiliaLayoutComponent,
    children: [{ path: '', component: EspacoDaFamiliaComponent }],
  },

  { path: '**', redirectTo: '' },
];
